import { Component } from '@angular/core';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-scheduled-maintenance',
  templateUrl: './scheduled-maintenance.component.html',
  styleUrls: ['./scheduled-maintenance.component.scss']
})
export class ScheduledMaintenanceComponent {
  constructor(
    public notificationService: NotificationService
  ){}

  ngOnInit(): void {
    this.notificationService.getNotifications().subscribe();
  }
}
